import React, { useEffect, useState } from "react";
import { styled, useTheme, Theme, CSSObject } from '@mui/material/styles';
import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next'
import MenuItem from '@mui/material/MenuItem';
import LocaleChanger from '../../LocaleChanger';
import Menu from '@mui/material/Menu';
import Link from "next/link";
import CommunityMenu from "../community";
import ArrowUnderMenu from "../../ArrowUnderMenu";
import AboutUsMenu from "../aboutUs";

//
const MyMainMenu = styled(Menu)({
    ".MuiMenu-paper": {
        background: "#292c2e",
        color: "white",
        minWidth: "210px",
        "& li": {
            transition: "all .1s linear",
            fontWeight: 700,
            fontSize: "14px",
            padding: "8px 25px 8px 25px",
            "&:hover": {
                //transform: "scale(1.1, 1.1)",
                background: "#383d40"
            }
        }
    }
});


// Component
function MainMenu(props: any) {
    const theme = useTheme();
    const isSmall = useMediaQuery(theme.breakpoints.down('sm'));
    const { t } = useTranslation();
    const [anchorEl, setAnchorEl] = useState<undefined | HTMLElement>(undefined);
    const openCommMenu = Boolean(anchorEl);

    // Community menu!
    const handleClick = (event: any) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (e: any, comm: string) => {
        if (props.socialUrls[comm]) {
            window.open(props.socialUrls[comm], "_blank");
        }

        setAnchorEl(undefined);
        e.stopPropagation();
    };

    // About us menu!
    const [anchorElAboutUs, setAnchorElAboutUs] = useState<undefined | HTMLElement>(undefined);

    //
    const handleClickAboutUs = (event: any) => {
        setAnchorElAboutUs(event.currentTarget);
    };

    const handleCloseAboutUs = (e: any, comm: string) => {
        setAnchorElAboutUs(undefined);
        e.stopPropagation();
    };

    //
    function getMenuItem(el: any) {
        let item = (
            <MenuItem key={el.id} onClick={(e) => props.handleClose(e, el.id)}>
                <Box>{el.icon}</Box>
                <Box sx={{ fontSize: "17px", marginLeft: "10px" }}>{el.label} </Box>
            </MenuItem>
        );

        if (el.link) {
            item = (
                <Link key={el.id} href={el.link} passHref>
                    {item}
                </Link>
            )
        }

        if (el.id === 'community') {
            item = (
                <MenuItem key={el.id} onClick={(e) => handleClick(e)}>
                    <Box>{el.icon}</Box>
                    <Box sx={{ fontSize: "17px", marginLeft: "10px", position: "relative" }}>
                        {el.label}
                        <ArrowUnderMenu horizontal={-100} open={openCommMenu} sx={{ padding: "0px", position: "absolute", left: '30px', top: "14px" }} />
                    </Box>
                </MenuItem>
            );
        }
        else if (el.id === 'about_us') {
            item = (
                <MenuItem key={el.id} onClick={(e) => handleClickAboutUs(e)}>
                    <Box>{el.icon}</Box>
                    <Box sx={{ fontSize: "17px", marginLeft: "10px", position: "relative" }}>
                        {el.label}
                        <ArrowUnderMenu horizontal={-100} open={anchorElAboutUs !== undefined} sx={{ padding: "0px", position: "absolute", left: '30px', top: "14px" }} />
                    </Box>
                </MenuItem>
            );
        }

        return item;
    }

    return (
        <MyMainMenu
            id="basic-menu"
            anchorEl={props.anchorEl}
            open={props.open}
            onClose={props.handleClose}
            MenuListProps={{
                'aria-labelledby': 'basic-button',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 20,
            }}>

            {
                props.menuOpts.map((el: any) => {
                    return (
                        getMenuItem(el)
                    );
                })
            }

            <CommunityMenu horizontal={-35} anchorEl={anchorEl} open={openCommMenu} handleClose={handleClose} socialUrls={props.socialUrls} />
            <AboutUsMenu horizontal={-35} anchorEl={anchorElAboutUs} open={anchorElAboutUs !== undefined} handleClose={handleCloseAboutUs} />
            {/*<LocaleChanger siteLang={props.siteLang} mystyle={{ margin: "20px 10px 0px 25px" }} />*/}
        </MyMainMenu>
    );
}

// Default style!
const MyMenuStyled = styled(MainMenu)({

});

// Export
export default MyMenuStyled;
